/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelExciseTaxRate.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/excise-tax-rate";

export class AutogenModelExciseTaxRate<RowType extends ModelRow> extends Endpoint<RowType, RowExciseTaxRateFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowExciseTaxRate extends ModelRow<RowExciseTaxRateFields> {
	constructor(values?: Partial<RowExciseTaxRateFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowExciseTaxRateFields {
	company_id: string;
	create_at: string;
	effective_date: Date;
	excisetax_code_id: string;
	id: string;
	is_canadian: string;
	method: string;
	rate: number;
	state_id: string;
}

